import React from 'react';
import { Button, Modal, ModalClose, Typography, Sheet } from '@mui/joy';
import Clear from '@mui/icons-material/Clear';
import CreateUser from '../../components/Admin/Pages/createuser';
const loginText = `This feature allows administrators to log in as a user to troubleshoot issues and view account details. When needed, click "Login as" on a user's profile to temporarily access their dashboard, settings, and data. Admin permissions are retained, and actions are logged for security. Exercise caution, obtain user consent, and notify them of troubleshooting steps. Use the "Return to Admin" link to return to the admin session. Use this feature judiciously to respect user privacy. For common issues and assistance, contact the support team.`;
const contentType = {
    'login-as': loginText,
};

const returnConfirmationBtn = (contentType, props) => {
    if (contentType === 'login-as') {
        return (
            <Button onClick={() => { props.onClose(); props.impersonateSignin(); }} className="summary-report-btn">
                Start Login As
            </Button>
        );
    }

    if (contentType === "create-us") {
    
      return (
        <>
      
        <CreateUser userpack={props.package} onClose={props.onClose} fetchdata={props.fetchData}/>
        </>
         
      );
    }

    if (contentType === 'delete-btn') {
        return (
            <div className='delete-btn-div'>
                <Button className='cancel' onClick={() => { props.onClose(); }}>Cancel</Button>
                <Button className='delete' onClick={() => { props.onClose(); props.deleteUser(); }}>Delete</Button>
            </div>
        );
    }
};

const InfoModal = (props) => {
    return (
        <Modal
            open={props.isOpen}
            onClose={props.onClose}
            sx={{
                backdropFilter: 'blur(8px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            className={"info-modal "+ props.contentType}
        >
            <Sheet
                sx={{
                    bgcolor: 'background.paper',
                    borderRadius: 'md',
                    p: 3,
                    boxShadow: 24,
                    width: '400px', // You can adjust the width as needed
                }}
            >
                <Typography level="h6" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <h2 className='modal-header-drop'> {props.header} </h2>                    
                    <ModalClose onClick={props.onClose} />
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                    {contentType[props.contentType] && contentType[props.contentType]}
                </Typography>

                <div className={"info-modal-confirmation "+ props.contentType+'-btn'} style={{ marginTop: '20px' }}>
                    {returnConfirmationBtn(props.contentType, props)}
                </div>
            </Sheet>
        </Modal>
    );
};

export default InfoModal;
